import { useFeatureFlag } from '../hooks/useFeatureFlag';
import type { FeatureFlagName } from '../configuration/featureFlags';

type Props = {
    name: FeatureFlagName;
    children: React.ReactNode;
};

export const FeatureFlag = ({ name, children }: Props) => {
    const enabled = useFeatureFlag(name);
    if (!enabled) {
        return null;
    }
    return <>{children}</>;
};
